/**
 * returningUserFlag — controla a memória "este navegador já tem cadastro".
 *
 * Quando setado, o AuthModal prioriza a aba "Já tenho conta" como default.
 * Quando ausente, prioriza "Sou consumidor" (estímulo a novos cadastros).
 *
 * Implementação: cookie de 1º-party + fallback em localStorage para casos
 * onde cookies estão bloqueados (alguns iframes/incognito).
 */

const COOKIE_NAME = 'ec_returning_user';
const STORAGE_KEY = 'ec_returning_user';
const MAX_AGE_SECONDS = 60 * 60 * 24 * 365; // 1 ano

export function markReturningUser() {
  try {
    document.cookie =
      `${COOKIE_NAME}=1; max-age=${MAX_AGE_SECONDS}; path=/; samesite=lax`;
  } catch { /* cookies bloqueados */ }
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch { /* storage bloqueado */ }
}

export function isReturningUser() {
  try {
    if (document.cookie && document.cookie.split(';').some(
      (c) => c.trim().startsWith(`${COOKIE_NAME}=1`),
    )) return true;
  } catch { /* ignore */ }
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch { return false; }
}

export function clearReturningUser() {
  try {
    document.cookie = `${COOKIE_NAME}=; max-age=0; path=/`;
  } catch { /* ignore */ }
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch { /* ignore */ }
}
